import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-slate-950 text-slate-400 py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <img src="/logo-white.png" alt="AFGestiones — Gestión y Administración de Fincas" data-testid="footer-brand" className="h-14 w-auto" />
            <p className="mt-5 text-sm leading-relaxed">Administración de Fincas.</p>
          </div>
          <div data-testid="footer-legal" className="md:justify-self-end">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-slate-500 mb-4">Legal</p>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/aviso-legal" data-testid="footer-link-aviso-legal" className="hover:text-white transition-colors duration-300">Aviso Legal</Link>
              <Link to="/politica-de-privacidad" data-testid="footer-link-privacidad" className="hover:text-white transition-colors duration-300">Política de Privacidad</Link>
              <Link to="/politica-de-cookies" data-testid="footer-link-cookies" className="hover:text-white transition-colors duration-300">Política de Cookies</Link>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-600">
          <span data-testid="footer-copyright">© 2026 AFGestiones. Todos los derechos reservados.</span>
          <span>Orden, cuentas claras y tranquilidad.</span>
        </div>
      </div>
    </footer>
  );
}
